// Kitchen Display System API Client

import { api } from '../api';
import {
  KDSOrder,
  KitchenStation,
  UpdateOrderItemStatusRequest,
  UpdateOrderPriorityRequest,
  BumpOrderRequest,
} from '../../types/kds';

export const kdsApi = {
  // Orders
  getActiveOrders: async (): Promise<KDSOrder[]> => {
    const { data } = await api.get<KDSOrder[]>('/api/kds/orders');
    return data;
  },

  getOrdersByStation: async (stationId: string): Promise<KDSOrder[]> => {
    const { data } = await api.get<KDSOrder[]>(`/api/kds/orders/station/${stationId}`);
    return data;
  },

  updateItemStatus: async (
    itemId: string,
    request: UpdateOrderItemStatusRequest
  ): Promise<void> => {
    await api.patch(`/api/kds/items/${itemId}/status`, request);
  },

  bumpOrder: async (orderId: string, request?: BumpOrderRequest): Promise<void> => {
    await api.post(`/api/kds/orders/${orderId}/bump`, request || {});
  },

  updateOrderPriority: async (
    orderId: string,
    request: UpdateOrderPriorityRequest
  ): Promise<void> => {
    await api.patch(`/api/kds/orders/${orderId}/priority`, request);
  },

  // Kitchen Stations
  getActiveStations: async (): Promise<KitchenStation[]> => {
    const { data } = await api.get<KitchenStation[]>('/api/kitchen-stations');
    return data;
  },

  getAllStations: async (): Promise<KitchenStation[]> => {
    const { data } = await api.get<KitchenStation[]>('/api/kitchen-stations/all');
    return data;
  },

  createStation: async (station: Partial<KitchenStation>): Promise<KitchenStation> => {
    const { data } = await api.post<KitchenStation>('/api/kitchen-stations', station);
    return data;
  },

  updateStation: async (
    stationId: string,
    station: Partial<KitchenStation>
  ): Promise<KitchenStation> => {
    const { data } = await api.put<KitchenStation>(
      `/api/kitchen-stations/${stationId}`,
      station
    );
    return data;
  },

  deleteStation: async (stationId: string): Promise<void> => {
    await api.delete(`/api/kitchen-stations/${stationId}`);
  },
};
